module.exports = __webpack_public_path__ + "static/media/graph.de0bd82b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/graph.svg
// module id = 862
// module chunks = 0